var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import 'i18next';
import { BasePartner } from '../BasePartner';
import { DisclaimerText } from '../../../DisclaimerText/DisclaimerText';
import SectionHeader from '../../../../clearstep/SectionHeader/SectionHeader';
import { SourceOfCare } from '../../../../clearstep/proto/results_pb';
import { getSentenceCase } from '../../../../clearstep/util/RenderHelpers';
import styles from './Baycare.css';
import { logEvent, MessageType, linkToAndLogConvo } from '../../../../../util/EventLog';
import { AppRegistration } from '../../../../svg/AppRegistration';
import { Devices } from '../../../../svg/Devices';
import { LocalHospital } from '../../../../svg/LocalHospital';
import { WalkInCareIcon } from '../../../../svg/partners/baycare/WalkInCare';
import { UrgentCareIcon } from '../../../../svg/partners/baycare/UrgentCareIcon';
import { HomeCareFindPharmacyIcon } from '../../../../svg/HomeCareFindPharmacyIcon';
import { Partner } from '../../../../clearstep/proto/partners_pb';
import { CoronavirusIcon } from '../../../../svg/CoronavirusIcon';
import { StethoscopeCircleIcon } from '../../../../svg/StethoscopeCircleIcon';
import CareCard from '../../../CareCard/CareCard';
import { isAndroid, isIOS } from '../../../../clearstep/util/AppHelpers';
import { VirtualVisitCareOptionIcon } from '../../../../svg/VirtualVisitCareOptionIcon';
import { THEME } from '../../../../clearstep/util/Theme';
import ResultsCard from '../../../ResultsCard/ResultsCard';
import { optionWithCareDetailCard, isEligibilityResult } from '../CareDetails';
import Button from '../../../../tailwind_common/Button';
import '../../../../clearstep/Types';
import { RetailClinicOption } from '../../../CareOption/CareOptionContentByCareType/RetailClinicOption';
import '../../../../../api/ConversationResults';
import NewPatientSelect from '../../../LocationSearchFilters/NewPatientSelect';
import { getSpecialistCustomizations } from './SpecialistCustomizations';
/* eslint-disable class-methods-use-this */
var BayCarePartner = /** @class */ (function (_super) {
    __extends(BayCarePartner, _super);
    function BayCarePartner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CovidInfoCareCard = function () {
            var t = useTranslation().t;
            return (React.createElement(CareCard, { title: t('baycare.covidInfoCard.title', 'Get the latest information on COVID-19'), icon: React.createElement(CoronavirusIcon, null), buttons: [
                    {
                        url: 'https://baycare.org/coronavirus',
                        cta: t('baycare.covidInfoCard.cta', 'Visit the Baycare COVID-19 resource center'),
                    },
                ] }));
        };
        _this.CovidTestingCareCard = function (props) {
            var t = useTranslation().t;
            var isAsymptomatic = props.isAsymptomatic, isSymptomatic = props.isSymptomatic, isTestToTreat = props.isTestToTreat;
            var buttons;
            var description;
            if (isSymptomatic) {
                buttons = [
                    {
                        url: 'https://baycare.org/services/urgent-care',
                        cta: t('baycare.covidTestingCard.symptomatic.cta', 'Find an urgent care near me to get a COVID test'),
                    },
                ];
                description = t('baycare.covidTestingCard.symptomatic.description', 'BayCare Urgent Care clinics offer traditional PCR testing in conjunction with an urgent care visit and evaluation by a health care provider. The PCR test is sent to BayCare Laboratories for processing.\n\n BayCare Urgent Care also can perform a rapid antigen test in combination with an urgent care visit and evaluation by a health care provider. The test is for symptomatic individuals within the first 7 days of symptom onset. Patients receive results in 15 minutes.');
            }
            else if (isAsymptomatic) {
                buttons = [
                    {
                        url: 'https://baycare.org/locations?searchTerms=PCR&page=0&pageSize=10&returnWildcardResults=true&FacilityType=Urgent%20Care&useDefaultLocation=false&lat=27.8823821&lng=-82.0407137&searchDistance=500',
                        cta: t('baycare.covidTestingCard.asymptomatic.cta', 'Find a BayCare Urgent Care to get a COVID test'),
                    },
                ];
                description = t('baycare.covidTestingCard.asymptomatic.description', 'BayCare offers an effective and reliable rapid PCR test that can detect COVID-19 in 30 minutes. The test is available by appointment at thirteen BayCare Urgent Care locations to asymptomatic people wishing to confirm they are negative for COVID-19, such as before traveling. The test is not billed to insurance but is available as a self-pay service at a cost of $150.');
            }
            else {
                buttons = [
                    {
                        url: 'https://baycare.org/coronavirus/covid-19-testing-centers?tid=a046f00001PKzEB&utm_campaign=BayCare-General&utm_source=ClearStep&utm_medium=Organic&utm_content=Clearstep_Testing_BUC-a3A6f00000GfD0b&utm_term=',
                        cta: t('baycare.covidTestingCard.default.cta', 'Learn more about testing options'),
                    },
                ];
                description = t('baycare.covidTestingCard.default.description', 'There are different testing resources available depending on people’s needs. Community and retail sites (such as pharmacies) offer free testing, while BayCare Urgent Care can provide testing in conjunction with an urgent care visit and evaluation by a health care provider. If you’re unable to get an appointment at a testing site, home tests are available for purchase at retail stores and online. BayCare Emergency Rooms are NOT providing public testing.');
            }
            if (isTestToTreat) {
                buttons.push({
                    url: 'https://covid-19-test-to-treat-locator-dhhs.hub.arcgis.com/',
                    cta: t('baycare.covidTestingCard.testToTreat.cta', 'Get tested and treated for COVID-19 at a pharmacy near you'),
                });
            }
            return (React.createElement(CareCard, { title: t('baycare.covidTestingCard.title', 'Get tested for COVID-19'), icon: React.createElement(HomeCareFindPharmacyIcon, null), description: description, buttons: buttons }));
        };
        _this.publixWalkInCare = function () {
            var t = useTranslation().t;
            return (React.createElement("div", { className: styles.baycare__resourceDescription },
                WalkInCareIcon(),
                React.createElement("p", { className: styles.baycare__resourceSubDescription }, t('baycare.retailClinic.description', 'Located inside select Publix pharmacies, Walk-In Care allows patients to have a telehealth visit with a provider in minutes. Walk-in Care leverages BayCareAnywhere kiosks that offer the availability of devices that you and your provider can use during your visit. From a blood pressure cuff to a thermometer and high-definition camera, these smart devices can help your provider make a more accurate diagnosis. And if your doctor prescribes medication, you can have it conveniently sent to the Publix pharmacy or to any other pharmacy you prefer.')),
                React.createElement("p", { className: styles.baycare__resourceSubDescription },
                    React.createElement("div", { className: styles.baycare__bulletHeader },
                        React.createElement("b", null, t('baycare.retailClinic.learnMore.header', 'Learn more about Publix Walk-In Care below:'))),
                    React.createElement("div", { className: styles.baycare__bulletPoints },
                        React.createElement("p", null, t('baycare.retailClinic.learnMore.bullet1', '1. Pre-enroll by signing up for a BayCareAnywhere account.')),
                        React.createElement("p", null, t('baycare.retailClinic.learnMore.bullet2', '2. Find the nearest Walk-In Care location that is convenient for you.')),
                        React.createElement("p", null, t('baycare.retailClinic.learnMore.bullet3', '3. At Publix, go the pharmacy and tell the team you would like to have a Walk-In Care visit.')),
                        React.createElement("p", null, t('baycare.retailClinic.learnMore.bullet4', '4. You will be shown into a private room and given helpful tips on how to use the BayCareAnywhere telehealth kiosk and how to sign in.')),
                        React.createElement("p", null, t('baycare.retailClinic.learnMore.bullet5', '5. Pay the $59* fee and begin your visit. Your provider may instruct you to use some of the devices in the kiosk to check your temperature, pulse, etc.')),
                        React.createElement("p", null, t('baycare.retailClinic.learnMore.bullet6', '6. If you provider prescribes medication, you may have it sent to the Publix pharmacy or another pharmacy of your choice.'))))));
        };
        _this.renderInfluenzaVaccineResultsCard = function (fluVaccineCareOption, retailClinicProps) {
            var complaint = retailClinicProps.complaint, careLocations = retailClinicProps.careLocations, zipCode = retailClinicProps.zipCode, insuranceStatus = retailClinicProps.insuranceStatus, isNewPatient = retailClinicProps.isNewPatient, costEstimate = retailClinicProps.costEstimate, showCostEstimate = retailClinicProps.showCostEstimate, setZipFocus = retailClinicProps.setZipFocus, isLoading = retailClinicProps.isLoading, mixSchedulingAndNonLocations = retailClinicProps.mixSchedulingAndNonLocations;
            var t = useTranslation().t;
            return (React.createElement(ResultsCard, null,
                React.createElement("h3", { className: "mb-5 text-left text-1.5xl font-bold leading-7.5 mobile:text-lg mobile:leading-6.5" }, t('baycare.retailClinic.title', 'Publix Walk-In Care')),
                _this.publixWalkInCare(),
                React.createElement(RetailClinicOption, { complaint: complaint, sourceOfCare: fluVaccineCareOption, careLocations: careLocations, zipCode: zipCode, insuranceStatus: insuranceStatus, isNewPatient: isNewPatient, costEstimate: costEstimate, showCostEstimate: showCostEstimate, setZipFocus: setZipFocus, isLoading: isLoading, mixSchedulingAndNonLocations: mixSchedulingAndNonLocations })));
        };
        _this.behavioralHealthOption = function () {
            var t = useTranslation().t;
            return (React.createElement(CareCard, { buttons: [
                    {
                        cta: t('basePartner.behavioralHealthCard.cta', 'Find more information'),
                        url: 'https://baycare.org/services/behavioral-health',
                        lookerTags: {
                            behavioralHealth: '1',
                        },
                    },
                ], description: t('baycare.behavioralHealthCard.description', 'BayCare Behavioral Health is the largest full-service, community-based health care system in the Tampa Bay area. We offer a variety of services in Pinellas, Hillsborough, Polk, Pasco and Hernando counties. We provide a full range of comprehensive services for mental health and addiction issues tailored to meet the needs of children, adults and families.'), noMargin: true }));
        };
        _this.schedulingLinkImage = function (href) {
            var t = useTranslation().t;
            var imgText = t('baycare.altText.schedulingLink', 'Save Your Spot');
            return (React.createElement("a", { href: href, target: "_blank", rel: "noopener noreferrer", onClick: function () {
                    return logEvent(MessageType.CLICKED_PARTNER_CARE_OPTION, { data: { text: imgText } }, { partner: THEME.partner });
                }, className: styles.baycare__saveYourSpot },
                React.createElement("img", { alt: imgText, src: "/static/images/partners/baycare/saveyourspot.svg" })));
        };
        return _this;
    }
    BayCarePartner.prototype.careOptionTitle = function (options) {
        var t = useTranslation().t;
        switch (options.careType) {
            case SourceOfCare.Type.TELEMEDICINE:
                return t('baycare.telemedicine.title', 'BayCareAnywhere telehealth visit');
            case SourceOfCare.Type.URGENT_CARE:
                return t('baycare.urgentCare.title', 'BayCare Urgent Care');
            case SourceOfCare.Type.PRIMARY_CARE:
                return t('baycare.primaryCare.title', 'Primary care visit');
            case SourceOfCare.Type.RETAIL_CLINIC:
                return t('baycare.retailClinic.title', 'Publix Walk-In Care');
            case SourceOfCare.Type.SPECIALIST:
                return this.getSpecialistTitle(options.careDetails, options.title);
            case SourceOfCare.Type.BEHAVIORAL_HEALTH:
                return t('baycare.behavioralHealth.title', 'Behavioral Health Treatment Resources');
            default:
                return getSentenceCase(options.title);
        }
    };
    BayCarePartner.prototype.bayCareAnywhereLogo = function () {
        var t = useTranslation().t;
        var logoAltText = t('baycare.altText.appLogo', 'BayCareAnywhere logo');
        return (React.createElement("div", { className: styles.baycare__logo },
            React.createElement("a", { href: BayCarePartner.bayCareAnywhereUrl, target: "_blank", rel: "noopener noreferrer", onClick: function () {
                    return logEvent(MessageType.LINK_CLICK, {
                        name: 'BayCareAnywhere image',
                    }, { partner: THEME.partner });
                } },
                React.createElement("img", { className: styles.baycare__anywhereLogo, src: "/static/images/partners/baycare/baycare_anywhere_logo.png", alt: logoAltText }))));
    };
    BayCarePartner.prototype.careOptionDescription = function (options) {
        var t = useTranslation().t;
        var careType = options.careType;
        switch (careType) {
            case SourceOfCare.Type.TELEMEDICINE:
                return (React.createElement("div", { className: styles.baycare__resourceDescription },
                    this.bayCareAnywhereLogo(),
                    React.createElement("p", { className: styles.baycare__resourceSubDescription }, t('baycare.telemedicine.description', 'A telehealth visit with a health care provider (often referred to as telemedicine or virtual visit) is a convenient, and often more affordable alternative to an in-person visit. A provider will meet with you over video via your smartphone, tablet, or computer, and may refer you to a specialist for additional care, if appropriate.'))));
            case SourceOfCare.Type.RETAIL_CLINIC:
                return this.publixWalkInCare();
            case SourceOfCare.Type.URGENT_CARE:
                return (React.createElement("div", { className: styles.baycare__resourceSubDescription },
                    React.createElement("div", { style: { marginBottom: '10px' } }, UrgentCareIcon()),
                    React.createElement("p", { className: styles.baycare__resourceDescription }, t('baycare.urgentCare.description1', 'Urgent care provides same-day or next-day medical care when you have a minor illness or injury and you are unable to be seen by your primary care provider. An urgent care center has clinical staff and equipment to take care of a broad range of illnesses and injuries for adults and children. Most urgent care centers are able to do x-rays and lab work. It is typically less costly than an emergency room.')),
                    React.createElement("p", { className: styles.baycare__resourceDescription }, t('baycare.urgentCare.description2', 'With convenient locations across Tampa Bay and surrounding areas, we offer everything from preventive care such as physicals, to urgent care for colds and flu, for adults and children age 2 and older. With extended evening and weekend hours, you can walk in when it’s convenient for you or use our convenient online scheduling tool, Save Your Spot. Choose your location and the time you’d like to come in and we’ll hold your place in line.'))));
            default:
                return null;
        }
    };
    BayCarePartner.prototype.baycareButtonResource = function (buttonCta, buttonUrl, careType) {
        return (React.createElement(Button, { onClick: function () {
                return linkToAndLogConvo(buttonUrl, MessageType.CLICKED_PARTNER_CARE_OPTION, {
                    name: careType,
                }, { partner: Partner.BAYCARE });
            } }, buttonCta));
    };
    BayCarePartner.prototype.partnerOptionWithCareDetail = function (options) {
        var t = useTranslation().t;
        var specialistCustomizations = getSpecialistCustomizations(t);
        return optionWithCareDetailCard(options.careDetails || [], specialistCustomizations);
    };
    BayCarePartner.prototype.virtualVisitOptions = function () {
        var t = useTranslation().t;
        var buttonCta = t('baycare.telemedicine.cta', 'Start a telehealth visit');
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.baycare__virtualCareIconsContainer },
                React.createElement("div", { className: styles.baycare__virtualCareIconContainer },
                    React.createElement(Devices, { width: "100px", alt: "", ariaHidden: true }),
                    React.createElement(Trans, { t: t, i18nKey: "baycare.telemedicine.downloadApp" },
                        React.createElement("p", { className: styles.baycare__virtualCareIconText },
                            "Download the BayCareAnywhere app from your iPhone or Android app store or go to",
                            ' ',
                            React.createElement("a", { href: BayCarePartner.bayCareAnywhereUrl, onClick: function () {
                                    return logEvent(MessageType.LINK_CLICK, {
                                        url: BayCarePartner.bayCareAnywhereUrl,
                                        text: 'BayCareAnywhere',
                                    }, { partner: THEME.partner });
                                }, target: "blank", rel: "noopener noreferrer" }, "BayCareAnywhere.org.")))),
                React.createElement("div", { className: styles.baycare__virtualCareIconContainer },
                    React.createElement(AppRegistration, { width: "100px", alt: "", ariaHidden: true }),
                    React.createElement("p", { className: styles.baycare__virtualCareIconText }, t('baycare.telemedicine.createAccount', 'Create an account.'))),
                React.createElement("div", { className: styles.baycare__virtualCareIconContainer },
                    React.createElement(StethoscopeCircleIcon, { width: "100px", alt: "", ariaHidden: true, viewBox: "-6 -6 68 68" }),
                    React.createElement("p", { className: styles.baycare__virtualCareIconText }, t('baycare.telemedicine.chooseProvider', 'Choose a provider and start your visit.'))),
                React.createElement("div", { className: styles.baycare__virtualCareIconContainer },
                    React.createElement(LocalHospital, { width: "100px", alt: "", ariaHidden: true }),
                    React.createElement("p", { className: styles.baycare__virtualCareIconText }, t('baycare.telemedicine.pharmacyNote', 'If necessary for your treatment, your provider may send a prescription to your local pharmacy.')))),
            React.createElement("p", { className: styles.baycare__buttonCta },
                React.createElement("b", null, t('baycare.telemedicine.ctaPrompt', 'Click below to start a telehealth visit:'))),
            this.baycareButtonResource(buttonCta, BayCarePartner.bayCareAnywhereUrl, SourceOfCare.Type.TELEMEDICINE)));
    };
    BayCarePartner.prototype.primaryCareOption = function () {
        var t = useTranslation().t;
        var buttonCta = t('baycare.primaryCare.cta', 'Schedule an appointment online');
        var buttonUrl = 'https://baycare.org/doctors#sort=relevancy&f:@specialties=[Primary%20Care]&f:@onlineappointments=[Yes]';
        return (React.createElement("div", null,
            React.createElement("p", { className: styles.baycare__buttonCta },
                React.createElement("b", null, t('baycare.primaryCare.ctaPrompt', 'Find a BayCare primary doctor near you'))),
            this.baycareButtonResource(buttonCta, buttonUrl, SourceOfCare.Type.PRIMARY_CARE)));
    };
    BayCarePartner.prototype.homeCareProviderOption = function () {
        var t = useTranslation().t;
        return (React.createElement(React.Fragment, null,
            React.createElement(SectionHeader, { text: t('baycare.home.header', 'Still want to talk to a healthcare provider?') }),
            this.careOptionDescription({ careType: SourceOfCare.Type.TELEMEDICINE }),
            this.virtualVisitOptions()));
    };
    BayCarePartner.prototype.emergencyAdditionalGuidanceOption = function () {
        var t = useTranslation().t;
        var buttonCta = t('baycare.emergencyAddlGuidance.cta', 'See all BayCare emergency departments');
        var buttonURL = 'https://baycare.org/locations?&page=0&pageSize=10&returnWildcardResults=true&FacilityType=Emergency%20Center&useDefaultLocation=false&zipcode=false&searchDistance=500';
        return (React.createElement("section", null,
            React.createElement("h1", { className: styles.baycare__additionalGuidanceHeader }, t('baycare.emergencyAddlGuidance.title', 'Want additional guidance?')),
            this.baycareButtonResource(buttonCta, buttonURL, SourceOfCare.Type.ER)));
    };
    BayCarePartner.prototype.disclaimer = function () {
        var t = useTranslation().t;
        return (React.createElement("div", { className: "pt-10  text-xs font-medium text-dark-gray" },
            React.createElement(SectionHeader, { className: "text-black", text: t('common.disclaimerTitle', 'Disclaimer & acknowledgment') }),
            React.createElement(DisclaimerText, null),
            React.createElement(Trans, { t: t, i18nKey: "basePartner.disclaimerLink" },
                React.createElement("div", { className: "pb-4" },
                    "View",
                    ' ',
                    React.createElement("a", { className: "inline-flex items-center font-semibold text-primary no-underline hover:underline", href: "https://www.clearstep.health/terms-and-conditions", target: "_blank", rel: "noopener noreferrer" }, "full terms"),
                    ".")),
            React.createElement(Trans, { t: t, i18nKey: "baycare.disclaimerLink" },
                React.createElement("div", { className: "pb-4" },
                    "View full BayCare terms",
                    ' ',
                    React.createElement("a", { className: "inline-flex items-center font-semibold text-primary no-underline", href: "https://baycare.org/about-us/terms-of-use", target: "_blank", rel: "noopener noreferrer" }, "here"),
                    "."))));
    };
    BayCarePartner.prototype.showWebsiteLinkIconForCareLocation = function (careType) {
        return (careType === SourceOfCare.Type.URGENT_CARE || careType === SourceOfCare.Type.RETAIL_CLINIC);
    };
    BayCarePartner.prototype.testingResource = function (options) {
        var isSymptomatic = options.isSymptomatic, isAsymptomatic = options.isAsymptomatic, isTestToTreat = options.isTestToTreat;
        return (React.createElement(React.Fragment, null,
            React.createElement(this.CovidTestingCareCard, { isSymptomatic: isSymptomatic, isAsymptomatic: isAsymptomatic, isTestToTreat: isTestToTreat }),
            React.createElement(this.CovidInfoCareCard, null)));
    };
    BayCarePartner.prototype.covidRelatedEmergencyResponse = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(CareCard, { title: "Find a Hospital", icon: React.createElement(StethoscopeCircleIcon, null), buttons: [
                    {
                        cta: 'Find a BayCare hospital',
                        url: 'https://baycare.org/services/emergency-care',
                    },
                ] }),
            React.createElement(this.CovidInfoCareCard, null)));
    };
    BayCarePartner.prototype.covidDoctorTriageResponse = function (options) {
        var t = useTranslation().t;
        var isMobileDevice = isIOS() || isAndroid();
        var logoAltText = t('baycare.altText.appLogo', 'BayCareAnywhere logo');
        var exampleAltText = t('baycare.altText.example', 'BayCareAnywhere virtual visit example');
        return (React.createElement(ResultsCard, null,
            React.createElement("h1", null, t('common.findCareNearYou', 'Find care near you')),
            React.createElement(React.Fragment, null,
                options.hasTelemedicineSupport && (React.createElement("section", null,
                    React.createElement("header", null,
                        React.createElement(VirtualVisitCareOptionIcon, null),
                        React.createElement("h4", null, t('basePartner.covidDoctorTriage.doctorCareCard.title', 'Speak with a doctor'))),
                    React.createElement("div", { className: styles.baycare__anywhereAssets },
                        React.createElement("div", null,
                            React.createElement("a", { href: BayCarePartner.bayCareAnywhereAssetUrl(), target: "_blank", rel: "noopener noreferrer", onClick: function () {
                                    return logEvent(MessageType.CLICKED_PARTNER_CARE_OPTION, { name: 'BayCareAnywhere image' }, { partner: THEME.partner });
                                } },
                                React.createElement("img", { className: styles.baycare__anywhereLogo, src: "/static/images/partners/baycare/baycare_anywhere_logo.png", alt: logoAltText }))),
                        React.createElement("div", null,
                            React.createElement("a", { href: BayCarePartner.bayCareAnywhereAssetUrl(), target: "_blank", rel: "noopener noreferrer", onClick: function () {
                                    return logEvent(MessageType.CLICKED_PARTNER_CARE_OPTION, { name: 'BayCareAnywhere image' }, { partner: THEME.partner });
                                } },
                                React.createElement("img", { src: "/static/images/partners/baycare/baycare_anywhere_example.png", alt: exampleAltText })))),
                    isMobileDevice && (React.createElement("div", { className: styles.baycare__anywhereMobileApp },
                        React.createElement(Trans, { t: t, i18nKey: "baycare.virtualVisit.appLink" },
                            React.createElement("div", { className: styles.baycare__anywhereMobileAppCTAText },
                                "Start a Virtual Visit in the",
                                ' ',
                                React.createElement("b", null, "BayCareAnywhere app"))),
                        this.bayCareAnywhereMobileAppButton())),
                    !isMobileDevice && (React.createElement(Button, { onClick: function () {
                            return linkToAndLogConvo('https://baycare.org/baycareanywhere', MessageType.CLICKED_PARTNER_CARE_OPTION, { name: 'Start a BayCareAnywhere virtual visit' });
                        } }, t('basePartner.virtualVisit.buttonText', 'Start a Virtual Visit'))))),
                options.hasTestingSupport && (React.createElement("section", null,
                    React.createElement(this.CovidTestingCareCard, { isSymptomatic: options.isSymptomatic, isAsymptomatic: options.isAsymptomatic, isTestToTreat: options.isTestToTreat }))),
                React.createElement("section", null,
                    React.createElement(this.CovidInfoCareCard, null)))));
    };
    BayCarePartner.prototype.bayCareAnywhereMobileAppButton = function () {
        var t = useTranslation().t;
        if (isIOS()) {
            var url = 'https://itunes.apple.com/us/app/baycare-anywhere/id1120215083?mt=8';
            var downloadAltText = t('baycare.altText.iosDownload', 'Download on App Store');
            return (React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer", onClick: function () {
                    return logEvent(MessageType.CLICKED_PARTNER_CARE_OPTION, { name: 'BayCareAnywhere image' }, { partner: THEME.partner });
                } },
                React.createElement("img", { className: styles.baycare__anywhereAppStore, src: "/static/images/partners/baycare/download_on_app_store.svg", alt: downloadAltText })));
        }
        if (isAndroid()) {
            var url = 'https://play.google.com/store/apps/details?id=org.baycare.android.bahs.baycareanywhere&hl=en';
            var downloadAltText = t('baycare.altText.androidDownload', 'Get It On Google Play');
            return (React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer", onClick: function () {
                    return logEvent(MessageType.CLICKED_PARTNER_CARE_OPTION, { name: 'BayCareAnywhere image' }, { partner: THEME.partner });
                } },
                React.createElement("img", { className: styles.baycare__anywhereGooglePlay, src: "/static/images/partners/baycare/google_play_badge.png", alt: downloadAltText })));
        }
        return null;
    };
    BayCarePartner.bayCareAnywhereAssetUrl = function () {
        if (isIOS()) {
            return 'https://itunes.apple.com/us/app/baycare-anywhere/id1120215083?mt=8';
        }
        if (isAndroid()) {
            return 'https://play.google.com/store/apps/details?id=org.baycare.android.bahs.baycareanywhere&hl=en';
        }
        return 'https://baycare.org/baycareanywhere';
    };
    BayCarePartner.prototype.locationSearchFilters = function (options) {
        if (options.careOptions &&
            options.careOptions.length === 1 &&
            options.careOptions[0].careType === SourceOfCare.Type.PRIMARY_CARE) {
            // Dont' render the zip/patient dropdown if we're only rendering in-person care (just link to baycare.org, don't need it)
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(NewPatientSelect, { prompt: "Are you a new patient?", required: false, placeholder: "", requestData: options.requestData, setRequestData: options.setRequestData })));
    };
    BayCarePartner.prototype.showZipcodeInput = function (careOptions) {
        if (careOptions && careOptions.length > 0) {
            // If we only show PRIMARY_CARE / TELEMEDICINE - don't show b/c for Baycare these care options override location search
            return !careOptions.every(function (careOption) {
                return careOption.careType === SourceOfCare.Type.PRIMARY_CARE ||
                    careOption.careType === SourceOfCare.Type.TELEMEDICINE;
            });
        }
        if (careOptions.length === 1) {
            var _a = careOptions[0], careType = _a.careType, careDetails = _a.careDetails;
            return !isEligibilityResult(careType, careDetails);
        }
        return true;
    };
    BayCarePartner.prototype.schedulingLinkConfig = function (location) {
        var schedulingLink = location.schedulingLink;
        if (!schedulingLink) {
            return null;
        }
        return {
            schedulingLinkImg: this.schedulingLinkImage(schedulingLink),
            schedulingLink: schedulingLink,
        };
    };
    BayCarePartner.prototype.shinglesVaccineCareOption = function () {
        var t = useTranslation().t;
        return (React.createElement(CareCard, { title: t('baycare.shinglesVaccineCard.title', 'Shingles (Shingrix) Vaccine'), buttons: [
                {
                    url: 'https://baycare.org/services/primary-care/immunizations-for-seniors',
                    cta: t('baycare.shinglesVaccineCard.cta', 'Schedule shingles vaccine'),
                },
            ] }));
    };
    BayCarePartner.bayCareAnywhereUrl = 'https://baycareanywhere.org';
    return BayCarePartner;
}(BasePartner));
export { BayCarePartner };
